import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, where } from "firebase/firestore";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, Axios);

const db = getFirestore();

Vue.use(VueAxios, Axios);

export default {
    state:{
        couponsList: [],
    },
    mutations:{
        SET_COUPONS_LIST(state, couponsList){
            state.couponsList = couponsList
        },
    },
    actions:{
        GetCouponsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "couponsList"))
                    const couponsList = []
                    for (const doc of querySnapshot.docs) {
                        let coupon = doc.data()
                        if(coupon.subscription !== ''){
                            coupon.subscription = await(await getDoc(coupon.subscription)).data()
                        }
                        couponsList.push(coupon)
                    }
                    commit('SET_COUPONS_LIST', couponsList)
                    resolve(couponsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        GetCoupon({}, coupon){
            return new Promise(async (resolve, reject) => {
                try {
                    let resCoupon = await getDoc(doc(db, "couponsList", coupon.id))
                    let gettedCoupon = resCoupon.data()
                    if(gettedCoupon.subscription !== ''){
                        gettedCoupon.subscription = await(await getDoc(gettedCoupon.subscription)).data()
                    }
                    gettedCoupon.expirationDate = gettedCoupon.expirationDate.toDate()
                    resolve(gettedCoupon)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateCoupon({}, coupon) {
            return new Promise(async(resolve, reject) => {
                try {
                    if(coupon.subscription !== ''){
                        coupon.subscription = doc(db, "subscriptionsList", coupon.subscription.id)
                    }
                    const newDocRef = doc(collection(db, "couponsList"));
                    coupon.id = newDocRef.id;
                    coupon.createdAt = new Date()
                    coupon.updatedAt = new Date()
                    await setDoc(newDocRef, coupon)
                    resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateCoupon({}, coupon) {
            return new Promise(async(resolve, reject) => {
                try {
                    if(coupon.subscription !== ''){
                        coupon.subscription = doc(db, "subscriptionsList", coupon.subscription.id)
                    }
                    if(coupon.createdAt) {
                        delete coupon.createdAt
                    }
                    coupon.updatedAt = new Date()
                    await updateDoc(doc(db, "couponsList", coupon.id), coupon)
                    resolve(coupon.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DisableCoupon({}, coupon){
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "couponsList", coupon.id), {
                      enabled: !coupon.enabled
                    })
                    resolve(coupon.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteCoupon({}, coupon) {
            return new Promise(async(resolve, reject) => {
                try {
                    await deleteDoc(doc(db, "couponsList", coupon.id))
                    resolve(coupon.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        VerifyExistingCoupon({}, coupon) {
            return new Promise(async(resolve, reject) => {
                try {
                    let validateCoupon = query(collection(db, "couponsList"), where("code", "==", coupon.code))
                    if (coupon.id) {
                        validateCoupon = query(collection(db, "couponsList"), where("code", "==", coupon.code), where("id", "!=", coupon.id))
                    }
                    const querySnapshot = await getDocs(validateCoupon)
                    resolve(querySnapshot.empty)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters:{
        getCouponsList(state){
            return state.couponsList;
        },
    }
}